function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
export var toastContainerPropTypes = {
  position: PropTypes.oneOf(['bottom', 'top']),
  newOnTop: PropTypes.bool
};
export var toastProviderPropTypes = _extends({}, toastContainerPropTypes, {
  domRoot: typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)
});